<!DOCTYPE html>
<html lang="tr-TR">

<head>
    <title>CARDATA Türkiye'nin Lider Otomotiv Datası Şirketi</title>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <base href="/">
    <script src="assets/js/jquery-3.3.1.js"></script>
    <script src="assets/js/plugins/jquery.masknumber.min.js"></script>
</head>

<body>
    <div class="page">
        <div class="container-fluid login">
            <div class="row">
                <div class="col-md-12">
                    <div class="box mt40 mb40 static">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="static-content">
                                    <p><b>Gizlilik Politikamız:</b></p>
                                    <p>
                                        Car Data Internatıonal-CDI Otomotiv Bilgi Hizmetleri A.Ş.’ne (kısaca CDI olarak
                                        anılacaktır) ait olan, web ve mobil tabanlı olarak sunulan CARDATA uygulaması
                                        (kısaca CARDATA olarak anılacaktır); gerek bireysel ve kurumsal üyelerinin
                                        /kullanıcıların verdikleri gerekse CDI’ın uygulama üzerinden elde ettiği
                                        bilgileri güvenlik ve gizlilik prensipleri doğrultusunda korunduğu interaktif
                                        bir platformdur.

                                    </p>
                                    <p>
                                        Gizliliğin sağlanması ve sürdürülebilirliği için, sözleşme ve kullanım
                                        koşullarında belirlenen istisnalar dışında gizli bilginin tamamının veya
                                        herhangi bir kısmının alenileşmesini ve yetkisiz kullanımını önlemek için
                                        gerekli tüm tedbirleri almakta ve gerekli özeni göstermekteyiz. Bu hususta
                                        gerekli özeni sizinde göstereceğinize inanıyoruz. Bu nedenle, kullanıcı uygun ve
                                        gerekli güvenlik önlemleri alınmış araçlarla sisteme ulaşmalı, virüs ve sair
                                        zararlı yazılımlara karşı gerekli tüm tedbirler almış olmalıdır. Ayrıca
                                        kullanıcı adı, giriş kodu, şifre vb. gibi CDI tarafından size özel verilmiş
                                        bilgilerinizi üçüncü kişilerle paylaşmamalısınız. Kişisel bilgileriniz, bu
                                        bilgilerin toplanması ile ilgili dokümanlarımızda açıklanan amaçlar (Kullanım
                                        Koşulları, ilgili Sözleşme ve Kişisel Verilerin Korunması Hakkında Aydınlatma
                                        Metni) ve sistem üzerinden vereceğiniz onay dışında, 3. kişilerle
                                        paylaşılmamakta ve kullanılmamaktadır.
                                    </p>
                                    <p>
                                        Üyelik, e-bülten abonmanlığı, web sitesi veya mobil uygulamaların
                                        kullanılabilmesi için istenen ve sizin tarafınızdan verilen bilgiler, kişisel
                                        veriler ve iletişim bilgileri (ad, soyad, telefon numarası, adres, e-posta
                                        adresi, fatura bilgileri, şehir, araca ait bilgiler gibi) hizmetten
                                        faydalanmanız için onay kodu yollanması, üye veya abonman kayıtlarının
                                        oluşturulması, sizinle temas kurulması veya doğrudan pazarlama yapılması
                                        amacıyla kullanabilmektedir. Sorgulama uygulamalarımızda yapacağınız
                                        sorgulamalara ait raporlamalar ve vereceğiniz iletişim bilgileriniz talebiniz
                                        olmaksızın başkalarıyla paylaşılmayacaktır. Sadece sizinle iletişime geçilmesini
                                        istemeniz halinde/koşuluyla, vermiş olduğunuz iletişim bilgileriniz ve
                                        uygulamadaki sorgulamaya ait raporlamanız sizinle iletişime geçecek birim
                                        personelimizle paylaşılacaktır. Bu talep/istek/onayınızı web sayfası veya mobil
                                        uygulamalar üzerindeki ilgili onay/talep kutucuklarını işaretleyerek
                                        vermektesiniz. Uygulamadaki bilgiler ve araç fiyat sorgulamaları kullanıcıya
                                        fikir vermeye yönelik öngörü/referans niteliğindedir, bu nedenle sorgulamalarda
                                        çıkan teknik veriler ile fiyat/fiyat aralıkları hiçbir şekilde kesinlik arz
                                        etmemektedir ve aracın kesin fiyatı olduğu yönünde CDI ın kullanıcıya karşı
                                        herhangi bir taahhüdü veya sorumluluğu bulunmamaktadır.
                                    </p>
                                    <p>
                                        Web/mobil sayfamızda yahut uygulamalarımızda talep edilen bilgiler, sizin
                                        tarafından sağlanan bilgiler, web sitesi yahut mobil uygulamalar üzerinden
                                        yapılan işlemlerle ilgili bilgiler, biz ve işbirliği içinde olduğumuz kişiler
                                        tarafından kullanıcının kimliği ifşa edilmeden çeşitli istatistiksel
                                        değerlendirmeler, veri tabanı oluşturma ve pazar araştırmalarında
                                        anonimleştirilerek kullanılabilecektir.
                                    </p>
                                    <p>
                                        CDI, başka sitelere link verebilir veya kendi sitesinde/mobil uygulamasında
                                        reklam veya linklere yer verebilir. Fakat bu halde link vasıtasıyla erişilen
                                        sitelerin gizlilik uygulamaları ve içeriklerine yönelik herhangi bir
                                        sorumluluğumuz bulunmamaktadır.
                                    </p>
                                    <p>
                                        Bireysel ve kurumsal üyelerimizin tüm bilgilerinin gizliliğini korumaya yönelik
                                        olarak wep sitemizde ve/veya mobil uygulamalarımıza üye/kullanıcı adı ve şifre
                                        ile ulaşımınız sağlanmaktadır. Üyenin/Kullanıcının siteden/mobil uygulamadan
                                        yararlanma hakkı sadece kendisine ait olup, başkalarına devredilemez ve
                                        kullandırılamaz. Üye/Kullanıcı adı ve şifresinin gizliliği ve sorumluluğu
                                        üye/kullanıcıya aittir. Üye/Kullanıcı adı ve şifreni üçüncü kişilere
                                        kullandırılmasından, güvenlik - gizlilik prensiplerine, sözleşme ve kullanım
                                        şartlarına uymamasından ve bu hususlarda gerekli özeni göstermemesinden kaynaklı
                                        CDI’ın doğrudan ve dolaylı uğrayacağı tüm zararlardan üye/kullanıcı sorumludur.
                                        Bu gibi hallerde doğabilecek her türlü hukuki, idari ve cezai sorumlulukta
                                        üye’ye/kullanıcı’ya aittir. Üye ve Kullanıcıların bu yükümlülüklerine ve
                                        sorumluluklarına aykırı davranması halinde, CDI, üye/kullanıcı hizmetlerini
                                        herhangi bir bildirimde bulunmaksızın tek taraflı olarak durdurma, üyeliği iptal
                                        etme, cezai ve hukuki başvuru haklarını kullanma ile uğradığı tüm zararların
                                        tazmin edilmesini isteme hakkına sahiptir. Kullanıcı şifresinin izinsiz
                                        kullanımın tespit etmesi halinde derhal bu durumu CDI’a bildirmelidir.

                                    </p>
                                    <p>CDI, uygulama ve modüllerin; Kanunlara ve sitemizde yer verilen Gizlilik
                                        Prensiplerine, Sözleşme veya Kullanım Koşullarına aykırı olarak kullanıldığını
                                        tespit ederse ve/veya yetkili mercilerce bu konuda bir tespit veya inceleme
                                        talebi gelirse, üye/abonman/kullanıcı ile ilgili bilgileri yetkili makamlara ve
                                        işlem yapacak mali müşavir veya avukatlara bildirmek ve gerekli diğer tedbirleri
                                        almak hakkına sahiptir.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <script src="js/plugins/owl.carousel.js" type="text/javascript"></script>
    <script src="js/plugins/jquery.fancybox.js" type="text/javascript"></script>
    <script src="js/plugins/sweetalert2.js" type="text/javascript"></script>
    <script src="js/plugins/is.js" type="text/javascript"></script>
    <script src="js/plugins/jquery.lazy.min.js" type="text/javascript"></script>
    <script src="js/plugins/jquery.validate.min.js" type="text/javascript"></script>
    <script src="js/plugins/messages_tr.js" type="text/javascript"></script>
    <script src="js/app.js" type="text/javascript"></script>
    <script src="js/plugins/jquery.marquee.min.js" type="text/javascript"></script>

</body>

</html>